export const identity = <T>(x: T): T => x;

export const noop = () => {
  /* no-op*/
};
